import React from 'react'
import { PageContent, ContentMenu, ContentMenuTab, Heading, Text, Image, Video } from 'components/library'
import { Slider } from './components/Slider.js'
import img01 from './assets/Untitled-3@3x.svg'
import img03 from './assets/voertuig@3x.svg'
import img04 from './assets/Untitled-6@3x.svg'
import img02 from './assets/slider-image-2@3x.svg'
import './Aspect02.css'

class Aspect02 extends React.Component {
  render() {
    return (
      <div className="Chapter02-Aspect02">
        <PageContent nospacing>
          <ContentMenu
            menuOnTop
            activeHasBackground
            tabs={[
              'Voorwaarden en Regels',
              'Procedure',
            ]}>

            <ContentMenuTab>
              <div className="has-padding">
                <div className="has-margin">
                  <Heading h2>Voorwaarden</Heading>
                  <ul>
                    <li>Je moet in het bezit zijn van een sleepbevoegdheid</li>
                    <li>De baankruising maakt deel uit van de door jou te volgen standaard sleeproute</li>
                  </ul>
                </div>
                <div>
                  <div>
                    <Heading h2>Regels</Heading>
                  </div>
                  <div>
                  <Slider>
                    <div>
                      <div className="Slider-carousel-tab">
                        <div className="Tab-text-wrapper">
                          <Text>Tijdens Uniforme Daglicht Periode (UDP), de periode vanaf 15 minuten voor zonsopgang tot 15 minuten na zonsondergang, geldt de standaard routering</Text>
                          <Text style={{ marginTop: '2rem' }}>Buiten UDP, de periode vanaf 15 minuten na zonsondergang, tot 15 minuten voor zonsopgang, geldt ook de standaard routering maar zijn alternatieve routes mogelijk. Apron Control moet het gebruik van deze routes afstemmen met LVNL.</Text>
                        </div>
                        <div>
                          <Image src={img01} style={{ width: '23.6rem'}} aspectRatio={84}/>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="Slider-carousel-tab">
                        <div className="Tab-text-wrapper">
                          <Text>Na het kruisen van een baan dien je voorrang te verlenen aan taxiënd verkeer, tenzij LVNL je heeft gemeld dat jij voorrang hebt.</Text>
                        </div>
                        <div>
                          <Image src={img02} style={{ width: '19.8rem'}} aspectRatio={100}/>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="Slider-carousel-tab">
                        <div className="Tab-text-wrapper">
                          <Text>Als een technische- of operationele verstoring op een baankruising begeleiding noodzakelijk maakt, zal Apron Control de sleepbeweging door een voertuig van Aircraft Operations laten begeleiden.</Text>
                        </div>
                        <div>
                          <Image src={img03} style={{ width: '26.7rem'}} aspectRatio={74}/>
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className="Slider-carousel-tab">
                        <div className="Tab-text-wrapper">
                          <Text>Indien een baan buiten gebruik is gesteld, doordat er bijvoorbeeld onderhoud wordt gepleegd, is er geen begeleiding nodig bij het kruisen. Tenzij de baan zelf onderdeel uitmaakt van de sleeproute, dan is er wel begeleiding vereist.</Text>
                        </div>
                        <div>
                          <Image src={img04} style={{ width: '23.9rem'}} aspectRatio={83}/>
                        </div>
                      </div>
                    </div>

                  </Slider>
                  </div>
                </div>
              </div>
            </ContentMenuTab>

            <ContentMenuTab>
              <Video vimeoId="332197075" />
            </ContentMenuTab>

          </ContentMenu>
        </PageContent>
      </div>
    )
  }
}

export default Aspect02



// WEBPACK FOOTER //
// ./src/content/chapters/02/02/Aspect02.js